{
  "version": 1,
  "asset_id": "c06d9209-11a7-4250-a590-7908e10928d6",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/c06d9209-11a7-4250-a590-7908e10928d6/g24.jpg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/c06d9209-11a7-4250-a590-7908e10928d6/g24.jpg",
  "original_filename": "g24.jpg",
  "size": 62081,
  "content_type": "image/jpeg",
  "created_at": "2026-07-02T23:00:11Z"
}
